import React, { useState, useEffect } from "react";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import { Dropdown } from "primereact/dropdown";

const url = "DBSIPPayoutReport/";
const GetConstruct_url = `${url}PopulateConstruct?`;
const GetDownload_url = `${url}DownloadDBSIPExcel?`;

const DistributorSIPPayoutReport = () => {
    const auth = storage.getLocal("user");
    const [isLoading, setIsLoading] = useState(false);
    const [constructs, setConstructs] = useState([]);
    const [selectedConstruct, setSelectedConstruct] = useState(null);

    useEffect(() => {
        searchConstruct();
    }, []);
    const searchConstruct = async () => {
        setIsLoading(true);
        try {
            const Construct_Url = `${GetConstruct_url}CompId=${auth.CompId}`;
            const response = await Axios.get(Construct_Url);
            const mappedData = response.data.Data.map((item) => ({
                Name: item.Name,
                ConstructId: item.Seq,
            }));
            setConstructs(mappedData);
        } catch (error) {
            toast.error(error?.response?.data?.Message || "Something went wrong", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const downloadReport = async () => {
        if (!selectedConstruct) {
            toast.warning("Please select a construct.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
            });
            return;
        }

        setIsLoading(true);

        try {
            const download_Url = `${GetDownload_url}CompId=${
                auth.CompId
            }&ConstructId=${
                selectedConstruct.ConstructId
            }&ConstructText=${encodeURIComponent(selectedConstruct.Name)}`;

            const response = await Axios.get(download_Url, {
                responseType: "blob",
                validateStatus: () => true,
            });
            const blob = response.data;
            const text = await blob.text();

            try {
                const json = JSON.parse(text);
                console.log("json", json);
                if (json?.Status === "Warning") {
                    toast.warning(json.Message || "No data available to download.", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                    return;
                }
            } catch (e) {
                console.log(e);
            }

            const fileBlob = new Blob([blob], {
                type: response.headers["content-type"] || "application/octet-stream",
            });

            if (fileBlob.size === 0) {
                toast.warning("No data available to download.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }

            const safeFileName = selectedConstruct.Name.replace(/[^a-z0-9]/gi, "_");
            const fileName = `Distributor_SIP_Payout_Report_${safeFileName}.xlsx`;

            const link = document.createElement("a");
            link.href = URL.createObjectURL(fileBlob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Download error:", error);
            toast.error("Failed to download the report.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Distributor SIP Payout Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <label className="form-label">Construct</label>
                                <Dropdown
                                    placeholder="Select Construct"
                                    value={selectedConstruct}
                                    options={constructs}
                                    optionLabel="Name"
                                    onChange={(e) => setSelectedConstruct(e.value)}
                                    className="w-100"
                                />
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={downloadReport}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? "Loading..." : "Download Report"}{" "}
                                        {isLoading ? (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        ) : (
                                            <Fa.FaDownload className="ms-2" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </>
    );
};

export default DistributorSIPPayoutReport;
